

const useGaurdEstimate = (page, prevUser, currentUser, history, props) => {
    if (!props.hasMyChart) { history.replace('/'); }
  
    if (currentUser
        && prevUser
        && (page.toLowerCase() === 'estimatedetails' )
        && prevUser.EID !== currentUser.EID) {
        history.replace('/estimates/myEstimates');
    }

}

export default useGaurdEstimate;